/* eslint-disable */
import { useEffect } from 'react';
import { createEventListener, useTealiumDataLayer, TealiumScript } from '@nextgen-web-framework/all';
import { EventService } from '@nextgen-web-framework/core';
import TEALIUM_EVENT_TOPICS, { POLL_INTERVAL, POLL_TIMEOUT } from './utils/constant';
import updateTransformerRegistry from './transformerMapping';
import updateLinkEventsMappingRegistry from './linkEventsMapping';

const TealiumSetup = () => {
  updateTransformerRegistry();
  updateLinkEventsMappingRegistry();
  const dataLayer = useTealiumDataLayer();
  useEffect(() => {
    let elapsed = 0;
    const uTagLinkHandler = createEventListener(dataLayer);
    let token: string[];
    const subscribeEvents = () => {
      token = EventService.subscribeMultiple(TEALIUM_EVENT_TOPICS, uTagLinkHandler);
    };
    const interval = setInterval(() => {
      elapsed += POLL_INTERVAL;
      if (typeof window.utag !== 'undefined') {
        window.utag.view(dataLayer);
        window.utag_data = { ...window.utag_data, ...dataLayer };
        clearInterval(interval);
      } else if (elapsed >= POLL_TIMEOUT) {
        clearInterval(interval);
      }
    }, POLL_INTERVAL);

    subscribeEvents();
    return () => {
      clearInterval(interval);
      EventService.unsubscribeMultiple(token);
    };
  }, [dataLayer]);
  return (
    <>
      <script
        data-testid="tealium-utag-data"
        id="tealium-data-layer"
        type="text/javascript"
        defer
        dangerouslySetInnerHTML={{
          __html: `window.utag_data = ${JSON.stringify(dataLayer)};`,
        }}
      />
      <TealiumScript />
    </>
  );
};

export default TealiumSetup;
